import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

/**
 * The photobooth's standard dialog: extra-wide, centred, dimmed light-dark backdrop, and no way to
 * close it by tapping outside or pressing Escape. Pass it (spread, plus any per-dialog overrides) to
 * every `NgbModal.open()`.
 *
 * Never set these on the app-wide `NgbModalConfig` instead. Until 2.17.2 `/terms` and
 * `/payment-or-promo` did that in their constructors; the change outlived the page, so a dialog
 * opened later looked different depending on whether a customer had reached those pages since
 * the app started (the /home staff PIN dialog was normal-width after a restart, extra-wide after
 * the first customer).
 */
export const PHOTOBOOTH_MODAL_OPTIONS: Readonly<NgbModalOptions> = Object.freeze({
  backdrop: 'static',
  keyboard: false,
  size: 'xl',
  backdropClass: 'light-dark-backdrop',
  centered: true,
});
